namespace Ir.Components.General.Loading {
    interface IViewModel {
        icon: string;
    }
    export function getViewModel(this: IViewModel, params, componentInfo) {
        this.icon = urlConfigs.siteRoot + "Content/irng_logo_simple.svg";
    }
}